export const DATA_IMPORT_FLAG = 'data_import';

/** Mirrors MAX_SOURCES in apps/data_import/serializers/upload_data_import_serializer.py. */
export const MAX_SOURCES = 3;

export const MAX_FILE_SIZE_IN_BYTES = 31_457_280;

export const CSV_FILE_TYPES = ['.csv'];

export const EID_TARGET_COLUMN = 'eid';

/**
 * In `target_columns` but rejected at publish: `eid` comes from each source's key column, and
 * managers are resolved by the import engine. Mirrors NON_MAPPABLE_TARGETS in
 * apps/data_import/services/people/build_people_mapped_records.py.
 */
export const NON_MAPPABLE_TARGET_COLUMNS = [EID_TARGET_COLUMN, 'manager', 'manager_id'];
